import { basicInitialState } from '../_utils/basicInitialState';
import { TVesselsState } from './vessels';

export const vesselsInitialState: TVesselsState = {
  ...basicInitialState,
  searchText: '',
  vessels: []
};
